module.exports = __webpack_public_path__ + "static/ada6-c91c71ac6ceee037aa23def86bd09199.jpg";